<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { initLiff, isLoggedIn } from './services/liff';
import { initApi } from './services/api';

const ready = ref(false);
const authenticated = ref(false);

onMounted(async () => {
  await initLiff();
  authenticated.value = isLoggedIn();
  
  if (authenticated.value) {
    await initApi();
  }
  
  ready.value = true;
});
</script>

<template>
  <div class="app">
    <template v-if="ready">
      <template v-if="authenticated">
        <router-view />
      </template>
      <template v-else>
        <div class="auth-error">
          <div class="icon">🔒</div>
          <h1>需要登入</h1>
          <p>請透過 LINE 開啟此頁面</p>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="loading">
        <div class="spinner"></div>
        <p>載入中...</p>
      </div>
    </template>
  </div>
</template>

<style>
.app {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.loading,
.auth-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  text-align: center;
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e0e0e0;
  border-top-color: #06c755;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading p {
  margin-top: 16px;
  color: #666;
  font-size: 14px;
}

.auth-error .icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.auth-error h1 {
  font-size: 20px;
  color: #333;
  margin-bottom: 8px;
}

.auth-error p {
  font-size: 14px;
  color: #666;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
